import React, { useState } from 'react';
import { NoticeWithRelations, useGetNoticesByPropertyIdQuery } from '../../../redux/residentPortalApi';
import { Box, Button, Modal, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, CardMedia } from '@mui/material';
import { makeStyles } from "@mui/styles";
import {theme} from "../../../theme/theme";
import {developmentInfo} from "../../../utils/propertyUtils";

interface OwnProps {
  propertyId: string;
  development: string;
}

const useStyles = makeStyles({
  modalStyle: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 600, // Set a fixed width or use max-width for responsiveness
    maxHeight: '80%',
    overflow: 'auto',
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
  },
  logoContainer: {
    display: 'flex',
    justifyContent: 'center', // Centers the child horizontally
    width: '100%', // Ensures the container takes full width of its parent
    marginBottom: theme.spacing(2),
  },
  logo: {
    width: '40%', // Adjusts logo size
  },
  table: {
    minWidth: 650,
  },
});

const NoticeTabContent: React.FC<OwnProps> = (props) => {
  const {propertyId, development} = props;
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [selectedNotice, setSelectedNotice] = useState<NoticeWithRelations | null>(null);
  const { data: notices, isFetching } = useGetNoticesByPropertyIdQuery({ propertyId });

  const handleOpen = (notice: NoticeWithRelations) => {
    setSelectedNotice(notice);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  if (isFetching) return <Typography>Loading...</Typography>;

  return (
    <Box>
      <TableContainer component={Paper}>
        <Table className={classes.table} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell>Title</TableCell>
              <TableCell>Submitted By</TableCell>
              <TableCell align="right">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {notices?.map((notice) => (
              <TableRow key={notice.id}>
                <TableCell component="th" scope="row">
                  {notice.title}
                </TableCell>
                <TableCell component="th" scope="row">
                  {notice.createdByUser?.name ?? 'Unknown'}
                </TableCell>
                <TableCell align="right">
                  <Button color="primary" onClick={() => handleOpen(notice)}>
                    View Details
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className={classes.modalStyle}>
          <Box className={classes.logoContainer}>
            <CardMedia
              component="img"
              image={developmentInfo(development).logo}
              alt="Development Logo"
              className={classes.logo}
            />
          </Box>
          <Typography id="modal-modal-title" variant="h1">
            {selectedNotice?.title}
          </Typography>
          {selectedNotice?.description && (
            <div
              id="modal-modal-description"
              dangerouslySetInnerHTML={{ __html: selectedNotice.description }}
            ></div>
          )}
        </Box>
      </Modal>
    </Box>
  );
};

export default NoticeTabContent;
